import styled from 'styled-components'
import { Copy, Link } from '@navinc/base-react-components'
import { useTerms } from '../hooks/apollo/use-terms'
import { usePartnerConfig } from '../hooks/use-partner-config'
const FooterContainer = styled(Copy).attrs(() => ({ size: 'sm' }))`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: center;
  height: 80px;
  padding: 16px 0 8px;
  background-color: ${({ theme }) => theme.navSecondary};
  color: ${({ theme }) => theme.navNeutralDark};
  bottom: 0;
  width: 100%;

  & * {
    line-height: 1.2;
  }

  & > * {
    color: ${({ theme }) => theme.navNeutralDark};
    padding: 0 16px;
    margin: 0 0 8px;
    border-left: 1px solid ${({ theme }) => theme.navNeutralDark};
  }
  & > *:first-child {
    border-left-width: 0;
  }

  @media (${({ theme }) => theme.largerThanPhone}) {
    margin-top: 0;
  }
`

export const Footer = () => {
  const { termsAvailability: { termsURL } = {} } = useTerms()

  const {
    configurations: { customTermsUrl },
  } = usePartnerConfig()

  return (
    <FooterContainer>
      {(!!termsURL || customTermsUrl) && (
        <Link target="_blank" href={customTermsUrl || termsURL}>
          Terms
        </Link>
      )}

      {(!!termsURL || customTermsUrl) && (
        <Link target="_blank" href={customTermsUrl || termsURL}>
          Privacy
        </Link>
      )}
    </FooterContainer>
  )
}
